import React from "react"

function Map({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5 24.6668L10.5 22.1668V11.3335L15.5 13.8335M15.5 24.6668L20.5 22.1668M15.5 24.6668V13.8335M15.5 13.8335L20.5 11.3335M20.5 22.1668L25.5 24.6668V13.8335L20.5 11.3335M20.5 22.1668V11.3335"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Map
